export const useGenerateMeta = (key, value) => {
  return {
    hid: key,
    name: key,
    content: value
  };
};
